import Vue from 'vue';
import ElementUI from 'element-ui';

/**
 * @MethodAuthor: Zhangwenwu
 * @Date: 2023-5-9 15:50:15
 * @Description: 统一格式化去除input首尾空格
*/
Vue.component('el-input', {
  extends: ElementUI.Input,
  created: function created() {
    var _this = this;
    this.$on('change', function (value) {
      _this.$emit('input', value.trim());
    });
  }
});